




















































































import { Component, Vue } from 'vue-property-decorator'
import GroupService from '@/services/GroupService'
import i18n from '@/lang'
import NotificationService from '@/services/NotificationService'
import { UnreadNoti } from '@/models'
import UnreadNotification from '@/components/UnreadNotification.vue'

const optionSelectAllGroup = {
  id: null,
  name: i18n.t('notification.all_group').toString()
}

@Component({
  components: {
    UnreadNotification
  }
})
export default class MentionList extends Vue {
  // search
  filterData: { id: number | null; name: string; listData: any[] } = {
    id: null,
    name: '',
    listData: []
  }

  // pagination
  private page: number = 1
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  isLoading: boolean = false
  isLoadingLoadMore: boolean = false
  isLastPage: boolean = true

  // list data to display
  mentionList: any[] = []
  countUnreadMention: number = 0

  selectGroupFilter(target: any) {
    this.filterData = {
      ...this.filterData,
      id: target.id,
      name: target.name
    }
  }

  clearCheckedState() {
    const mentionListRef: any = this.$refs.mentionListRef
    mentionListRef.isCheckAll = false
  }

  async getAllGroupUserJoin() {
    try {
      const response = await GroupService.getAllGroupCompact()

      if (response.status === 200) {
        const list = response.data.data
        list.unshift(optionSelectAllGroup)
        this.filterData = {
          id: optionSelectAllGroup.id,
          name: optionSelectAllGroup.name,
          listData: [...list]
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  async getUnreadMentionList(target_id?: number) {
    this.isLoading = this.page === 1
    this.isLoadingLoadMore = this.page > 1

    const params = {
      page: this.page,
      limit: this.limit,
      target_id
    }

    try {
      const response = await NotificationService.getUnreadMentionList(params)

      if (response.status === 200 && response.data.data) {
        this.isLastPage = this.page >= response.data.meta.pagination.total_pages

        const data = response.data.data.map(
          (item: any) => new UnreadNoti(item, 'text-line-clamp-2')
        )

        this.mentionList = [...this.mentionList, ...data]
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.isLoading = false
      this.isLoadingLoadMore = false
      // clear checked state after fetch data
      this.clearCheckedState()
    }
  }

  async getMentionCount(target_id?: number) {
    try {
      const response = await NotificationService.getUnreadMentionCount(
        target_id
      )

      if (response.status === 200) {
        this.countUnreadMention = response.data.count || 0
      }
    } catch (err) {
      console.log(err)
    }
  }

  async created() {
    this.getAllGroupUserJoin()
    await Promise.all([this.getUnreadMentionList(), this.getMentionCount()])
  }

  async searchMentionPostByGroup() {
    this.page = 1
    this.isLastPage = true
    this.mentionList = []
    await Promise.all([
      this.getUnreadMentionList(this.filterData.id || undefined),
      this.getMentionCount(this.filterData.id || undefined)
    ])
  }

  loadMoreMention() {
    this.page += 1
    this.getUnreadMentionList(this.filterData.id || undefined)
  }

  async markUnreadMentions(notificationIds: any) {
    this.$blockui.show()

    try {
      const response = await NotificationService.markReadedNotification(
        notificationIds
      )

      if (response.status === 200) {
        const readIds = notificationIds.notifications
        this.mentionList = this.mentionList.filter(
          ({ id }) => !readIds.includes(id)
        )

        // update count unread mention
        await this.getMentionCount(this.filterData.id || undefined)

        // fetch new data if all mention are mark read and still have data to fetch
        if (!this.mentionList.length && !this.isLastPage) {
          this.page = 1
          await this.getUnreadMentionList(this.filterData.id || undefined)
        }

        // clear checked state after mark read
        this.clearCheckedState()
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.$blockui.hide()
    }
  }
}
